import { appStore } from '@kaltura-ott/tvpil-shared';

export function checkTvpilErrorSuccessfullyCleared(id: number | undefined) {
  if (!appStore.apiError || !id) {
    return false;
  }

  return !Object.values(appStore.apiError).find((err) => err.id === id);
}
